import Project1 from "../../assets/project1.gif";
import Project2 from "../../assets/project2.webp";
import Project3 from "../../assets/project3.webp";
import Project4 from "../../assets/project4.png";
import Project5 from "../../assets/project5.png";
import Project6 from "../../assets/project6.png";
import Project7 from "../../assets/project7.png";
import Project8 from "../../assets/project8.png";
import Project9 from "../../assets/project9.png";
import Project10 from "../../assets/project10.png";
import Project11 from "../../assets/project11.png";
export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "open-world-pygames",
        category: "graphic",
        link: "https://template.xtramile.id/BM/Gp/"
    },
    {
        id: 2,
        image: Project2,
        title: "Rendering-Web_chat",
        category: "graphic",
    },
    {
        id: 3,
        image: Project3,
        title: "work with OpenStreetMap",
        category: "OSM",
    },
    {
        id: 4,
        image: Project4,
        title: "Business Management GP",
        category: "Business",
        link: "https://template.xtramile.id/BM/Gp/"
    },
    {
        id: 5,
        image: Project5,
        title: "ThewayShop",
        category: "E-commerce",
        link: "https://template.xtramile.id/HDE/ThewayShop/"
    },
    {
        id: 6,
        image: Project6,
        title: "Chamb E-commerce",
        category: "E-commerce",
        link: "https://template.xtramile.id/HDE/Chamb/"
    },
    {
        id: 7,
        image: Project7,
        title: "FreshShop",
        category: "E-commerce",
        link: "https://template.xtramile.id/HDE/Freshshop/"
    },
    {
        id: 8,
        image: Project8,
        title: "Architex - Architecture Template",
        category: "Architecture",
        link: "https://template.xtramile.id/GG/Architex/"
    },
    {
        id: 9,
        image: Project9,
        title: "Travel - Tourism Template",
        category: "Travel",
        link: "https://template.xtramile.id/GG/Travel/"
    },
    {
        id: 10,
        image: Project10,
        title: "Sotex - Business Template",
        category: "Business",
        link: "https://template.xtramile.id/GG/Sotex/"
    },
    {
        id: 11,
        image: Project11,
        title: "CivilEngineering - Engineering Template",
        category: "Engineering",
        link: "https://template.xtramile.id/GG/CivilEngineering/"
    },
];

export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "graphic",
    },
    {
        name: "Business",
    },
    {
        name: "E-commerce",
    },
    {
        name: "Architecture",
    },
    {
        name: "Travel",
    },
    {
        name: "Engineering",
    },
    {
        name: "OSM",
    },
];